import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'react-jss';
import { Button, Input, Select, Row } from 'antd';
import { useHistory } from 'react-router';
import { useForm, Controller } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import GetField from '../Components/GetField';
import styles from '../styles';
import { successNotification, errorNotification } from '../Snackbar';
import Api from '../Api';
import LeftGrid from '../Components/LeftGrid';
import RightGrid from '../Components/RightGrid';
import {
  clearUnitIds,
  getUnitIds,
  getColorIds,
  clearColorIds,
} from '../Actions';
import Breadcrumbs from '../Components/Breadcrumbs';

const AntInput = GetField(Input);
const AntSelect = GetField(Select);
const { Option } = Select;
const AntInputTextArea = GetField(Input.TextArea);

const CreateAccessory = props => {
  const { classes } = props;
  const history = useHistory();
  const dispatch = useDispatch();

  const { handleSubmit, control } = useForm();

  const [confirmLoading, setConfirmLoading] = useState(false);

  const unitIds = useSelector(state => state.unitIds);
  const colorIds = useSelector(state => state.colorIds);

  useEffect(() => {
    dispatch(getUnitIds());
    dispatch(getColorIds());
    return () => {
      dispatch(clearUnitIds());
      dispatch(clearColorIds());
    };
  }, []);

  const onSubmit = useCallback(async formValues => {
    try {
      setConfirmLoading(true);
      await Api.post('/accessories', formValues);
      successNotification('Accessory created');
      history.push('/accessories/list');
    } catch (err) {
      setConfirmLoading(false);
      errorNotification(err);
    }
  }, []);

  return (
    <>
      <Breadcrumbs
        moduleName="Accessory"
        moduleLink="/accessories/list"
        subModuleName="Create"
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <LeftGrid>
            <Controller
              name="name"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Name"
                  placeholder="Name"
                  {...field}
                />
              )}
            />
          </LeftGrid>
          <RightGrid>
            <Controller
              name="gsm"
              control={control}
              render={({ field }) => (
                <AntInput allowClear label="GSM" placeholder="GSM" {...field} />
              )}
            />
          </RightGrid>
        </Row>
        <Row>
          <LeftGrid>
            <Controller
              name="size"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Size"
                  placeholder="Size"
                  {...field}
                />
              )}
            />
          </LeftGrid>
          <RightGrid>
            <Controller
              name="unitId"
              control={control}
              render={({ field }) => (
                <AntSelect
                  allowClear
                  label="Unit"
                  placeholder="Select unit"
                  {...field}
                >
                  {unitIds.map(unit => (
                    <Option key={unit.id} value={unit.id}>
                      {unit.unit}
                    </Option>
                  ))}
                </AntSelect>
              )}
            />
          </RightGrid>
        </Row>
        <Row>
          <LeftGrid>
            <Controller
              name="quality"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Quality"
                  placeholder="Quality"
                  {...field}
                />
              )}
            />
          </LeftGrid>
          <RightGrid>
            <Controller
              name="colorId"
              control={control}
              render={({ field }) => (
                <AntSelect
                  allowClear
                  label="Color"
                  placeholder="Select color"
                  {...field}
                >
                  {colorIds.map(color => (
                    <Option key={color.id} value={color.id}>
                      {color.color}
                    </Option>
                  ))}
                </AntSelect>
              )}
            />
          </RightGrid>
        </Row>
        <Row>
          <LeftGrid>
            <Controller
              name="shade"
              control={control}
              render={({ field }) => (
                <AntInput
                  allowClear
                  label="Shade"
                  placeholder="Shade"
                  {...field}
                />
              )}
            />
          </LeftGrid>
          <RightGrid>
            <Controller
              name="remark"
              control={control}
              render={({ field }) => (
                <AntInputTextArea
                  allowClear
                  label="Remark"
                  placeholder="Remark"
                  {...field}
                />
              )}
            />
          </RightGrid>
        </Row>
        <Row className={classes.buttonContainer}>
          <Button type="primary" loading={confirmLoading} htmlType="submit">
            Submit
          </Button>
        </Row>
      </form>
    </>
  );
};

CreateAccessory.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CreateAccessory);
